import React, { Component } from 'react';
import $ from "jquery";

class ShowImg extends Component {

    constructor(props) {
        super(props);
        this.state = {
            hasImg: false,
            imgW: 0,
            imgH: 0,
            addClass: ""
        };
        this.intervalTime = null;
    }

    componentWillMount() {
        const that = this;
        const { item } = this.props;

        let ele = document.getElementById(item.detail.resourceID);
        if (ele && item.actionType === "ShowPic_") {
            that.setState({
                hasImg: true,
                imgW: parseInt(ele.style.width, 10),
                imgH: parseInt(ele.style.height, 10)
            }, () => {
                // alert(ele.style.display)
                if (ele.style.display === "none") {
                    setTimeout(() => {
                        ele.style.display = "block";
                    }, 100);
                }
            });
        }
    }

    componentDidMount() {
        const that = this;
        const { item } = this.props;
        const showEffects = item.detail.showEffects;    //飞入动画
        const zoomEffects = item.detail.zoomEffects;    //S2B_
        const ele = document.getElementById(item.detail.resourceID);
        const disappearEffect = item.detail.disappearEffect;    //飞出动画
        let duration = showEffects && showEffects.duration ? showEffects.duration : 0;
        let intervalT = 50;
        let startInterval = 0;
        if (disappearEffect && disappearEffect.type) {
            duration = disappearEffect.duration;
        }

        //zoomEffects动画是ShowPic_一个出现过的图片，因此不需要再渲染，通过resourceID去找之前的图片
        if (zoomEffects && zoomEffects.rate) {
            if (ele && item.actionType === "ShowPic_") {
                let _class = ele.className;
                window.zIndex++;

                if (ele.style.transform) {  //当元素之前有transform动画，会被覆盖，因此用animate动画
                    that.scaleAnimate(ele, 2);
                } else {
                    ele.setAttribute('class', _class + ' scale');
                }

                //动画完成后移除，防止多次对一个图片做动画失效
                setTimeout(() => {
                    ele.setAttribute('class', _class);
                    // ele.removeAttribute('class');
                }, 2500);
            }
        }

        if (ele) {
            let _class = ele.className;
            window.zIndex++;
            if (duration > 100) {  //有飞入动画的duration = 1000
                that.intervalTime = setInterval(() => {
                    let percent = startInterval / duration;
                    ele.style.zIndex = window.zIndex;

                    if (showEffects && showEffects.showEffectsType) {
                        const showEffectsType = showEffects.showEffectsType;
                        if (showEffects.showEffectsType === "LEntry_") {    //左飞入动画
                            ele.style.left = item.detail.pos.x * percent * 100 + "%";
                        } else if (showEffectsType === "REntry_") {    //右飞入动画
                            ele.style.left = (item.detail.pos.x + (1 - percent) * (1 - item.detail.pos.x)) * 100 + "%";
                        } else if (showEffectsType === "Down_") {    //上飞入动画
                            ele.style.top = item.detail.pos.y * percent * 100 + "%";
                        } else if (showEffectsType === "Up_") {    //下飞入动画
                            ele.style.top = (item.detail.pos.y + (1 - percent) * (1 - item.detail.pos.y)) * 100 + "%";
                        }
                    }

                    if (ele && disappearEffect && disappearEffect.type) {
                        const type = disappearEffect.type;
                        let _x = ele.style.left.replace("%", "") / 100;
                        let _y = ele.style.top.replace("%", "") / 100;
                        if (type === "LExit_") {    //左飞出动画
                            let _w = parseInt(ele.style.width, 10) / window.mainSize.width;
                            ele.style.left = (_x - (_x + _w) * percent) * 100 + "%";
                        } else if (type === "RExit_") {    //右飞出动画
                            ele.style.left = (_x + (1 - _x) * percent) * 100 + "%";
                        } else if (type === "Down_") {    //上飞出动画
                            let _h = parseInt(ele.style.height, 10) / window.mainSize.height;
                            ele.style.top = (_y - (_y + _h) * percent) * 100 + "%";
                        } else if (type === "Up_") {    //下飞出动画
                            ele.style.top = (_y + (1 - _y) * percent) * 100 + "%";
                        }
                    }

                    startInterval = startInterval + intervalT;
                    if (startInterval > duration) {
                        clearInterval(that.intervalTime);
                        // ele.style.zIndex = 0;
                    }
                }, intervalT);
            }

            if (item.actionType === "ShowPic_" && showEffects.showEffectsType === "Amazing_") { //动态飞入
                if (ele.style.transform) {  //当元素之前有transform动画，会被覆盖，因此用animate动画
                    that.scaleAnimate(ele);
                } else {
                    ele.setAttribute('class', _class + ' amazing');
                }
                ele.style.zIndex = window.zIndex;
                //动画完成后移除，防止多次对一个图片做动画失效
                setTimeout(() => {
                    ele.setAttribute('class', _class);
                    // ele.removeAttribute('class');
                }, 2500);
            }

            if (item.actionType === "ShowPic_" && showEffects.showEffectsType === "S2B_") { //动态飞入
                if (ele.style.transform) {  //当元素之前有transform动画，会被覆盖，因此用animate动画
                    that.scaleAnimate(ele, 2);
                } else {
                    ele.setAttribute('class', _class + ' scale');
                }
                ele.style.zIndex = window.zIndex;
                //动画完成后移除，防止多次对一个图片做动画失效
                setTimeout(() => {
                    ele.setAttribute('class', _class);
                    // ele.removeAttribute('class');
                }, 2500);
            }

            //动画完成，z-index改为0
            // ele.addEventListener("webkitAnimationEnd", function () {
            //     ele.style.zIndex = 0;
            //     console.log(ele.style.zIndex)
            // });
        }
    }

    componentWillUnmount() {
        clearInterval(this.intervalTime);
        // zIndex = 0;
    }

    scaleAnimate(ele, time) {
        let $ele = $(ele);
        if (!$ele.is(":animated")) {
            const { imgW, imgH } = this.state;
            $ele.stop().animate({
                width: imgW * 1.2,
                height: imgH * 1.2,
                marginTop: -(imgH * 1.2 - imgH) / 2,
                marginLeft: -(imgW * 1.2 - imgW) / 2
            }, 300, function () {
                $(ele).stop().animate({
                    width: imgW,
                    height: imgH,
                    marginTop: 0,
                    marginLeft: 0
                }, 300, function () {
                    if (time) {
                        $ele.stop().animate({
                            width: imgW * 1.2,
                            height: imgH * 1.2,
                            marginTop: -(imgH * 1.2 - imgH) / 2,
                            marginLeft: -(imgW * 1.2 - imgW) / 2
                        }, 300, function () {
                            $(ele).stop().animate({
                                width: imgW,
                                height: imgH,
                                marginTop: 0,
                                marginLeft: 0
                            }, 300);
                        })
                    }
                })
            });
        }
    }

    render() {
        const { item } = this.props;
        const { hasImg, addClass } = this.state;
        const showEffects = item.detail.showEffects;
        return (
            <div>
                {
                    !hasImg && item.actionType === "ShowPic_" ?
                        <div id={item.detail.resourceID} className={addClass} style={{
                            "position": "absolute",
                            "top": showEffects && showEffects.showEffectsType === "Down_" ? 0 : showEffects && showEffects.showEffectsType === "Up_" ? "100%" : item.detail.pos.y * 100 + "%",
                            "left": showEffects && showEffects.showEffectsType === "LEntry_" ? 0 : (showEffects && showEffects.showEffectsType === "REntry_" ? "100%" : item.detail.pos.x * 100 + "%"),
                            "width": item.detail.size.width / 2 * window.mainSize.percent + "px",
                            "height": item.detail.size.height / 2 * window.mainSize.percent + "px",
                            "background": `url(${window.resourceUrl + item.detail.resourceID}) 0 0 / contain no-repeat`,
                        }} />
                        : null
                }
            </div>
        );
    }
}

export default ShowImg;



// WEBPACK FOOTER //
// ./src/components/on/ShowImg.js